const ErrorFallback = ({ error }) => {
  console.log(error)
  return (
    <div className="content-wrapper">
      <article className="main">
        <p></p>
        <h2>
          <b>Internal server error (500)</b>
        </h2>
        <p>Sorry. An error has occurred on the website.</p>
        <p>You can:</p>
        <ul>
          <li>try refreshing the web page</li>
          <li>check again later</li>
          <li>
            go back to the <a href="https://www.fairwork.gov.au">homepage</a>
          </li>
        </ul>
        <p>
          See{' '}
          <a href="https://www.fairwork.gov.au/website-information/using-fairwork-gov-au">
            Using fairwork.gov.au
          </a>{' '}
          for more website features and technical information about this site.
        </p>
      </article>
    </div>
  )
}

export default ErrorFallback
